// Copyright 2022-2024 - Hewlett Packard Enterprise Company
import { Box, Button, Heading, Layer, Text } from 'grommet';
import { useTranslation } from 'react-i18next';
import { StatusWarningSmall } from '../Icons/AllStatusIcons';
import Notification from '../Notification/Notification';

export default function GroupDisabledModal({ groupName, onClose }) {
  const { t } = useTranslation('common');

  return (
    <Layer
      as="section"
      position="center"
      modal
      onClickOutside={onClose}
      onEsc={onClose}
    >
      <Box gap="none" pad="medium" width="586px">
        <>
          <Heading level={2} margin="none" truncate>
            {groupName}
          </Heading>
          <Notification
            icon={<StatusWarningSmall color="status-warning" size="large" />}
            pad={{ vertical: 'xsmall' }}
          >
            <Box>
              <Text size="large">
                {t('group_detail_page.group_disabled_modal.text')}
              </Text>
            </Box>
          </Notification>
        </>
        <Box justify="end" direction="row">
          <Button
            label={t('group_detail_page.group_disabled_modal.close_btn_label')}
            onClick={onClose}
            primary
          />
        </Box>
      </Box>
    </Layer>
  );
}
